import React from 'react'

import img from 'assets/images/compliancePage/memo_bg.jpg'

import classes from './Info.module.scss'

export const Info: React.FC = () => {
  return (
    <div className={`row ${classes.row}`}>
      <div className="col-xs-12">
        <h1 className={`title uppercase ${classes.title}`}>
          Памятка к Кодексу делового <br /> поведения и этики
        </h1>
      </div>

      <div className="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-xs-12">
        <img
          className={classes.img}
          src={img}
          alt="Памятка к Кодексу делового поведения и этики"
        />
      </div>

      <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12">
        <p className={classes.text}>
          Кодекс содержит принятые в МТС Медиа принципы, стандарты поведения и
          деловой практики, гарантирующие честное и справедливое отношение к
          членам нашей команды, партнерам, клиентам, а также соблюдение
          законодательства и внутренних нормативных актов компании.
        </p>
        <p className={classes.text}>
          Положения Кодекса распространяются на всех сотрудников и директоров
          МТС Медиа, вне зависимости от должности, обязанностей, стажа и места
          работы, включая все дочерние, зависимые и совместные предприятия,
          которыми мы управляем.
        </p>
      </div>
    </div>
  )
}
